<template>
  <div class="details">
    <b-container fluid>
      <div class="d-flex justify-content-center mt-2 mr-4 ml-4">
        <img class="logo-oem" alt="OMEGA EUROPEAN MASTERS" src="../assets/img/logo-2019.svg">
      </div>
      <h4 class="text-center mt-3 mb-0">{{ title }}</h4>
      <div class="oem-card-user text-center">
        <div class="oem-card-user-info mb-4 mt-0">
          <div class="oem-card-user-id-label">{{ $t('reference') }} :
            {{ this.$store.getters.reference.split('-')[0] }}
          </div>
          <div class="oem-card-user-id-label">{{ $t('partner') }} : {{ this.$store.getters.partner }}</div>
          <div class="oem-card-user-id-label">{{ $t('date') }} : {{ this.$store.getters.date }}</div>
          <div class="oem-card-user-name" v-if="this.$store.getters.guest !== ''">{{ $t('guest') }} :
            {{ this.$store.getters.guest }}
          </div>
          <img v-if="this.$store.getters.logoPartner !== ''"
               style="width: 50px; height: auto; display: block; margin:auto;"
               :src="this.$store.getters.logoPartner"/>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <div class="oem-zones-editor">
          <div v-if="this.$store.getters.msgRegister" class="text-center mb-4 text-success">
            {{ this.$store.getters.msgRegister }}
          </div>
          <form class="oem-zone-save-form" action="/action_page.php" method="get">
            <b-form-checkbox class="mb-3" v-model="zone.status" name="checkbox-1" :value="true"
                             :unchecked-value="false" v-for="zone in this.$store.getters.zones"
                             :key="zone.zone" disabled v-if="zone.status">
              {{ zone.zone }}
            </b-form-checkbox>
            <b-button class="mt-4" block type="button" :to="'/'">{{ $t('scan_again') }}</b-button>
          </form>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import BContainer from "bootstrap-vue/src/components/layout/container";

export default {
  name: 'detail',
  data: function () {
    return {
      title: 'Carte d\'accès',
    }
  },
  components: {
    BContainer
  },
  methods: {
    async onLogout() {
      this.$store.dispatch('logout');
      this.$router.push('partners');
    }
  },
  mounted() {
    if (!this.$store.getters.reference)
      this.$router.push('./');
  }
}
</script>
<style lang="scss">

</style>
